module.exports = __webpack_public_path__ + "img/highlight_3.d95083c1.png";